import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stackoverflow",
  "use": "icon-stackoverflow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-stackoverflow\"><defs><style type=\"text/css\"></style></defs><path d=\"M788.48 907.84v-253.76h84.16v338.24H112V654.08h84.16v253.76z\" fill=\"#BCBBBB\" p-id=\"3162\" /><path d=\"M289.28 630.08l413.76 86.4 17.6-83.2-413.76-86.4-17.6 83.2z m54.72-197.12l383.04 178.24 34.88-76.48L378.88 355.2l-34.88 77.76z m106.24-188.16l325.12 270.4 53.76-64.64-325.44-270.4-53.44 64.64z m209.92-200.32l-67.84 50.24 251.84 339.2L912 383.68l-251.84-339.2zM280.64 822.4h422.4v-84.16H280.64v84.16z\" fill=\"#F48023\" p-id=\"3163\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/stackoverflow.svg
// module id = 60RO
// module chunks = 40